import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import close from "../../asset/cross.png";
import Divider from "@mui/material/Divider";
import Chip from "@mui/material/Chip";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "470px", // Constrain on large screens
  minWidth: "300px", // Prevent from being too narrow
  overflowY: "auto", // Enable vertical scrolling
  display: "flex",
  flexDirection: "column",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  "@media (max-width: 600px)": {
    maxHeight: "80vh",

    fontSize: "0.9rem",
    padding: "15px",
  },
};

const pektastyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "470px",
  minWidth: "300px",
  flexDirection: "column",
  overflowY: "auto",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,

  "@media (max-width: 600px)": {
    fontSize: "0.9rem",
    padding: "15px",
  },
};

function applicationChip(value) {
  if (value === true) {
    return (
      <Chip
        sx={{ fontSize: "15px", fontWeight: "bold" }}
        label="Dibuka"
        color="success"
        size="large"
      />
    );
  } else {
    return (
      <Chip
        sx={{ fontSize: "15px", fontWeight: "bold" }}
        label="Ditutup"
        color="error"
        size="large"
      />
    );
  }
}

export const PektaModal = ({ open, closeModal, pekta, katam, pihtas }) => {
  return (
    <div>
      <Modal
        open={open}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={pektastyle}>
          <img
            src={close}
            alt="tutup"
            className="w-5 h-5 float-right cursor-pointer"
            onClick={closeModal}
          />
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            align="center"
          >
            Syarat-Syarat untuk memohon Pengkursus Ibadat Haji Tanah Air (PEKTA)
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2, ml: 1 }}>
            <div className="flex flex-row">
              <div className="flex-shrink-0 w-5">•</div>
              <div>Telah menunaikan haji.</div>
            </div>
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 0.5, ml: 1 }}>
            <div className="flex flex-row">
              <div className="flex-shrink-0 w-5">•</div>
              <div>Umur tidak melebihi 50 tahun.</div>
            </div>
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 0.5, ml: 1 }}>
            <div className="flex flex-row">
              <div className="flex-shrink-0 w-5">•</div>
              <div>
              Mempunyai tauliah mengajar yang sah dan masih berkuatkuasa dari pihak berkuasa Agama Islam Negeri.
              </div>
            </div>
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 0.5, ml: 1 }}>
            <div className="flex flex-row">
              <div className="flex-shrink-0 w-5">•</div>
              <div>
                Mempunyai latar belakang Pengajian Islam dengan kelulusan
                sekurang-kurangnya STAM atau setaraf.
              </div>
            </div>
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 0.5, ml: 1 }}>
            <div className="flex flex-row">
              <div className="flex-shrink-0 w-5">•</div>
              <div>
                Memiliki personaliti dan akhlak yang baik serta tidak merokok.
              </div>
            </div>
          </Typography>

          <Divider
            variant="middle"
            sx={{ bgcolor: "black", marginY: "20px" }}
          />

          <Typography id="modal-modal-description" sx={{ mt: 1, ml: 1 }}>
            <div className="flex flex-row justify-between">
              <div className=" font-semibold">Permohonan PEKTA</div>
              {applicationChip(pekta)}
            </div>
          </Typography>

          <Typography id="modal-modal-description" sx={{ mt: 1, ml: 1 }}>
            <div className="flex flex-row justify-between">
              <div className=" font-semibold">Permohonan KATAM</div>
              {applicationChip(katam)}
            </div>
          </Typography>

          <Typography id="modal-modal-description" sx={{ mt: 1, ml: 1 }}>
            <div className="flex flex-row justify-between">
              <div className=" font-semibold">Permohonan PIHTAS</div>
              {applicationChip(pihtas)}
            </div>
          </Typography>
        </Box>
      </Modal>
    </div>
  );
};

export const PihtasModal = ({ open, closeModal }) => {
  return (
    <div>
      <Modal
        open={open}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Syarat-Syarat untuk memohon PIHTAS
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2, ml: 1 }}>
            <div className="flex flex-row">
              <div className="flex-shrink-0 w-5">•</div>
              <div>
                Calon merupakan PEKTA yang mempunyai KATAM yang sedang
                berkuatkuasa.
              </div>
            </div>
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 0.5, ml: 1 }}>
            <div className="flex flex-row">
              <div className="flex-shrink-0 w-5">•</div>
              <div>Mempunyai Sijil Pembimbing Ibadat Haji (SPIH).</div>
            </div>
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 0.5, ml: 1 }}>
            <div className="flex flex-row">
              <div className="flex-shrink-0 w-5">•</div>
              <div>
                Aktif menyampaikan kursus haji{" "}
                <strong>
                  <i>TH</i>
                </strong>{" "}
                di peringkat negeri dan daerah sekurang-kurangnya 3 tahun
                selepas ditauliahkan sebagai PEKTA..
              </div>
            </div>
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 0.5, ml: 1 }}>
            <div className="flex flex-row">
              <div className="flex-shrink-0 w-5">•</div>
              <div>
                Tidak dilantik sebagai PIHTAS dalam tempoh 3 tahun berturut.
              </div>
            </div>
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 0.5, ml: 1 }}>
            <div className="flex flex-row">
              <div className="flex-shrink-0 w-5">•</div>
              <div>Mengurus sendiri pelepasan majikan.</div>
            </div>
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 0.5, ml: 1 }}>
            <div className="flex flex-row">
              <div className="flex-shrink-0 w-5">•</div>
              <div>
                Tidak terlibat membawa Jemaah haji syarikat swasta sekiranya
                dilantik.
              </div>
            </div>
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 0.5, ml: 1 }}>
            <div className="flex flex-row">
              <div className="flex-shrink-0 w-5">•</div>
              <div>Sihat tubuh badan dan umur tidak melebihi 60 tahun.</div>
            </div>
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 0.5, ml: 1 }}>
            <div className="flex flex-row">
              <div className="flex-shrink-0 w-5">•</div>
              <div>Sanggup bertugas melebihi 60 hari.</div>
            </div>
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 0.5, ml: 1 }}>
            <div className="flex flex-row">
              <div className="flex-shrink-0 w-5">•</div>
              <div>Berakhlak mulia dan tidak merokok.</div>
            </div>
          </Typography>
          <div className="mt-5 float-right">
            <button
              onClick={closeModal}
              className="h-11 w-24 bg-lime-700 text-white rounded-lg float-right"
            >
              Setuju
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};
